import { normalizeString } from "lib/actions/util";

export type ModelTextSearchResult<TModel extends object> = {
  model: TModel;
  search: {
    isMatch: boolean;
    matchStart: number | null;
    matchEnd: number | null;
  } | null;
};

export function getModelTextSearch<TModel extends object>(
  value: string,
  ...selectors: Array<(model: TModel) => string>
) {
  const term = normalizeString(value);
  const isSearchApplied = !!term;

  function search(models: TModel[]): ModelTextSearchResult<TModel>[] {
    return models
      ?.map((model) => {
        // Selectors are applied in order until a match is found, so the first match wins - other selectors get ignored then.
        let matchIndex = selectors.reduce(
          (prevMatchIndex, currentSelector) =>
            prevMatchIndex === -1
              ? normalizeString(currentSelector(model))?.indexOf(term) ?? -1
              : prevMatchIndex,
          -1,
        );

        const isMatch = isSearchApplied && matchIndex >= 0;

        return {
          model,
          search: isSearchApplied
            ? {
                isMatch,
                matchStart: isMatch ? matchIndex : null,
                matchEnd: isMatch ? matchIndex + term.length : null,
              }
            : null,
        };
      })
      .filter((x) => !x.search || x.search.isMatch);
  }

  return {
    isSearchApplied,
    search,
  };
}
